import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AppBar, Box, Toolbar, Typography, IconButton, Drawer, List } from '@mui/material';
import PropTypes from 'prop-types';
import MenuIcon from '@mui/icons-material/Menu';
import Logo from '../../../assets/logo/logo.png';

const LogoIcon = () => {
  return (
    <Link underline="none" to="/">
      <img src={Logo} style={{ height: '50px' }} alt="LOGO" />
    </Link>
  );
};

const Header = ({ sx }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const menuItems = (
    <>
      <Link to="/activities" style={{ textDecoration: 'none' }}>
        <Typography
          color="textSecondary"
          variant="h5"
          fontWeight="500"
          sx={{ ml: 1, my: 2, color: sidebarOpen ? 'black' : 'white' }}
        >
          Activities
        </Typography>
      </Link>
      <Link to="/about" style={{ textDecoration: 'none' }}>
        <Typography
          color="textSecondary"
          variant="h5"
          fontWeight="500"
          sx={{ ml: !sidebarOpen ? 4 : 1, my: 2, color: sidebarOpen ? 'black' : 'white', mr: 3 }}
        >
          About
        </Typography>
      </Link>
    </>
  );

  return (
    <>
      <AppBar
        sx={sx}
        elevation={0}
        style={{
          boxShadow: '0px 4px 33.8px 0px #00000033',
          backgroundColor: '#7d98a1',
          zIndex: 11,
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={toggleSidebar}
            sx={{ mr: 2, display: { xs: 'block', md: 'none' }, color: 'white' }}
          >
            <MenuIcon />
          </IconButton>
          <LogoIcon />
          <Box flexGrow={1}></Box>
          <Box
            sx={{
              display: { xs: 'none', md: 'flex', alignItems: 'center' },
              justifyContent: 'flex-end',
              width: '100%',
            }}
          >
            {menuItems}
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer anchor="left" open={sidebarOpen} onClose={toggleSidebar}>
        <Box
          sx={{ width: 250, m: 2 }}
          role="presentation"
          onClick={toggleSidebar}
          onKeyDown={toggleSidebar}
        >
          <List>{menuItems}</List>
        </Box>
      </Drawer>
    </>
  );
};

Header.propTypes = {
  sx: PropTypes.object,
};

export default Header;
